import { render } from "./PriceGroupForm.vue?vue&type=template&id=e71c0300&scoped=true"
import script from "./PriceGroupForm.vue?vue&type=script&lang=js"
export * from "./PriceGroupForm.vue?vue&type=script&lang=js"

import "./PriceGroupForm.vue?vue&type=style&index=0&id=e71c0300&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e71c0300"]])

export default __exports__